import { useEffect } from 'react';

const SITE_NAME = 'BigFollow';

/**
 * Sets document.title for pages that don't use SEOHead.
 * Accepts a page title string; appends " | BigFollow" automatically.
 */
export function usePageTitle(title: string) {
  useEffect(() => {
    const full = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    document.title = full;
  }, [title]);
}